<template>
  <div style="text-align: left;">
    <el-row :gutter="20">
      <el-col style="text-align: left;width: 60px">
        <el-upload
          v-show="fileArrays.length < limit "
          v-if="isEdit"
          :action="fileUrl"
          :on-remove="handleRemove"
          :limit="limit"
          :before-upload="beforeUpload"
          :show-file-list="false"
          :on-success="handleSuccess">
          <el-button slot="trigger" size="small" style="background-color: #006aff;border-color:#006aff;color: #FFFFFF" icon="el-icon-plus"></el-button>
        </el-upload>
      </el-col>
      <el-col style="text-align: left;width: calc(100% - 70px)">
        <span v-if="fileArrays.length === 0 && !isEdit">无</span>
        <el-tag v-for="(item , $index) in fileArrays"  :key="item.id"
          :style="{cursor:'pointer' , marginLeft: $index === 0 ? '0' : '10px', height:'33px'}"
          @close="deleteFile($event,item)"
          @click="downloadFile($event,item.file_id,item.file_name)"
          effect="plain"
          closable
          type="info">
          <span style="font-size: 13px;" :title="item.file_name">
             {{item.file_name | ellipsis(8)}}
          </span>
        </el-tag>
      </el-col>
    </el-row>


    <el-dialog
      title="图片预览"
      class="dialogFormW"
      appendToBody
      :visible.sync="dialogVisible"
      width="800px"
      :modal="true">
      <div>
        <img style="width:100%;" :src="getImgUrl()">
      </div>
      <span slot="footer">
        <el-button size="small" type="primary" @click="downloadPicture()">下载</el-button>
        <el-button size="small" type="primary" @click="dialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
  import {getFileAttachmentList, getFileAttachmentById, deleteFileById} from "./fileupload-restapi.js"
  import {guid} from "../util/string.util"
  export default {
    name: "UploadFile",
    props: {
      value: String, Number,
      fileType: {
        type: String,
        require: false
      },
      module: {
        type: String,
        require: true
      },
      isEdit: {
        type: Boolean,
        require: false
      },
      limit: {
        type: Number,
        require: false,
        default(){
          return 1;
        }
      },
    },
    watch: {
      value(val) {
        this.currentValue = this.value;
        if(this.currentValue){
          this.fileUrl = getFileServerUrl() + 'file/attachment/upload/' + this.tenantId + '/' + this.module + '/' + this.currentValue;
          this.getFileQuery();
        }else {
          this.handleInput();
        }
      },
    },
    data() {
      return {
        fileUrl: '',
        dialogVisible: false,
        fileArrays: [],
        pictureId: '',
        tenantId: sessionStorage.getItem("tenantId"),
        currentValue:"",
      }
    },
    created(){
      let $this = this;
      if (this.value === "" || this.value === null || this.value === undefined) {
        this.handleInput();
      }else {
        this.currentValue = this.value;
        this.$nextTick(()=>{
          this.getFileQuery();
        });
      }
      $this.fileUrl = getFileServerUrl() + 'file/attachment/upload/' + $this.tenantId + '/' + $this.module + '/' + $this.currentValue;
    },
    mounted(){
      let that = this;
    },
    methods: {
      handleInput(event) {
        let uuid = guid();
        this.currentValue = uuid
        this.$emit('input', uuid);
      },
      /** 文件上传  ---start*/
      handleRemove(file, tableData, row, scope, materials) {
        console.log(materials);
      },
      getFileQuery(){
        let $this = this;
        if (!$this.value) {
          return;
        }
        getFileAttachmentList($this.tenantId, $this.module, $this.value).then(res => {
          let fileArrays = res.data;
          this.fileArrays = fileArrays;
        })
      },
      isImage(name){
        return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(name.substring(name.lastIndexOf(".") + 1, name.length).toLowerCase()) !== -1;
      },
      beforeUpload(file){
        if (this.fileType === 'image') {
          if (!this.isImage(file.name)) {
            this.$notify({
              title: '失败',
              message: '请上传图片格式文件',
              type: 'warning'
            });
            return false;
          }
        }
        if (this.fileArrays.length >= 5) {
          this.$notify({
            title: '失败',
            message: '上传限制,最多五个文件',
            type: 'warning'
          });
          return false;
        }
        if (file.size > 1024 * 1024 * 1024) {
          this.$notify({
            title: '失败',
            message: '上传失败，文件过大，请重新上传',
            type: 'warning'
          });
          return false;
        }
      },
      handleSuccess(response, file, fileList){
        this.$notify({
          title: '成功',
          message: '添加成功',
          type: 'success'
        });
        this.getFileQuery();
      },
      deleteFile(event, item){
        let that = this;
        if (that.isEdit) {
          that.$confirm(`确定移除 ${ item.file_name }？`).then(_ => {
              //删除操作
              deleteFileById(item.id).then(res => {
                this.getFileQuery();
              })
            }
          );
        }
      },
      getImgUrl(){
        return getFileServerUrl() + "file/attachment/download/" + this.pictureId;
      },
      downloadPicture(){
        location.href = getFileServerUrl() + "file/attachment/download/" + this.pictureId;
      },
      isPicture(name){
        if (this.isImage(name)) {
          return true;
        } else {
          return false;
        }
      },
      hasFile(){
        return this.fileArrays.length > 0
      },
      isNotPicture(name){
        if (this.isImage(name)) {
          return false;
        } else {
          return true;
        }
      },
      downloadFile(event, id, name){
        if (event.srcElement.className.indexOf("el-icon-circle-close") > -1) {
          return;
        }
        this.pictureId = id;
        if (this.isImage(name)) {
          this.dialogVisible = true;
        } else {
          location.href = getFileServerUrl() + "/" + "file/attachment/download/" + id;
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/upload/FileUploadCommon.vue